import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/shop/null17393462605954.jpg?type=myboard&data_idx=942331&col_num=19&dir_name=sub2_1&thum_w=600&thum_h=600&thum_cut_yn=0'
import _imports_1 from '@/assets/img/testing/putt_h_2_0.png?type=myboard&data_idx=942331&col_num=21&dir_name=sub2_1&thum_w=600&thum_h=600&thum_cut_yn=0'
import _imports_2 from '@/assets/img/shop/1-4_putt_-jeon-hak-nyeon-yong-ji-ch1739346195a46d.jpg?type=myboard&data_idx=942331&col_num=27&dir_name=sub2_1&thum_w=600&thum_h=600&thum_cut_yn=0'
import _imports_3 from '@/assets/img/testing/putt_2_0_description_table.png?type=myboard&data_idx=942331&col_num=26&dir_name=sub2_1&thum_w=600&thum_h=600&thum_cut_yn=0'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/testing/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'High',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "진단검사",
      subtitle: "진단검사",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(BoardNavbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "sub_subject" }, "PUTT2.0 다중재능검사", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, [
              _createElementVNode("span", null, " 세상과 만나는 성취 경험 지표로서의"),
              _createTextVNode(" 다중재능검사_고등학생용 ")
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("figure", { class: "img_wrap" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }),
              _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              })
            ], -1))
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<div data-v-66bdb9a2><h2 data-v-66bdb9a2>검사 정보</h2><ul data-v-66bdb9a2><li data-v-66bdb9a2><dl data-v-66bdb9a2><dt data-v-66bdb9a2>저자</dt><dd data-v-66bdb9a2>강정하·김성호·<br data-v-66bdb9a2>김종헌·김민진</dd></dl></li><li data-v-66bdb9a2><dl data-v-66bdb9a2><dt data-v-66bdb9a2>대상</dt><dd data-v-66bdb9a2>고등학생</dd></dl></li><li data-v-66bdb9a2><dl data-v-66bdb9a2><dt data-v-66bdb9a2>검사유형</dt><dd data-v-66bdb9a2>자기보고식 검사</dd></dl></li><li data-v-66bdb9a2><dl data-v-66bdb9a2><dt data-v-66bdb9a2>문항수</dt><dd data-v-66bdb9a2>160문항</dd></dl></li><li data-v-66bdb9a2><dl data-v-66bdb9a2><dt data-v-66bdb9a2>소요시간</dt><dd data-v-66bdb9a2>20분-30분</dd></dl></li><li data-v-66bdb9a2><dl data-v-66bdb9a2><dt data-v-66bdb9a2>가격</dt><dd data-v-66bdb9a2>(1인당검사코드) 11,000원 (진단지침서) 11,000원</dd></dl></li></ul><div class=\"bg\" data-v-66bdb9a2><div data-v-66bdb9a2><h3 data-v-66bdb9a2><span data-v-66bdb9a2>저자</span>강정하</h3><p data-v-66bdb9a2> ㈜COKOLab. 대표이사<br data-v-66bdb9a2> 전 성균관대학교 아동청소년학과 겸임 교수<br data-v-66bdb9a2> 이화여자대학교 교육심리학 학사/석사, 성균관대학교 영재 및 창의성 교육 전공 박사<br data-v-66bdb9a2></p></div><div data-v-66bdb9a2><h3 data-v-66bdb9a2><span data-v-66bdb9a2>저자</span>김성호</h3><p data-v-66bdb9a2> KAIST 수리과학과 명예 교수<br data-v-66bdb9a2> 서울대학교 수학교육과 학사, 서울대학교 전산통계학과 석사, 카네기멜론대학교 통계학 박사 </p></div><div data-v-66bdb9a2><h3 data-v-66bdb9a2><span data-v-66bdb9a2>저자</span>김종헌</h3><p data-v-66bdb9a2> 대전과학고등학교 교사<br data-v-66bdb9a2> 공주대학교 교육학 박사 </p></div><div data-v-66bdb9a2><p data-v-66bdb9a2> 상표등록번호 제 40-1746432 호<br data-v-66bdb9a2> ISBN (검사) 979-11-981777-2-8<br data-v-66bdb9a2> 저작권등록번호 (검사) 제 C-2023-011635 호<br data-v-66bdb9a2> ISBN (진단지침서) 979-11-981777-0-4<br data-v-66bdb9a2> 저작권등록번호 (진단지침서) 제 C-2023-011636 호 </p></div></div></div><div data-v-66bdb9a2><h2 data-v-66bdb9a2>PUTT2.0 다중재능검사의 목적</h2><p data-v-66bdb9a2> 본 검사는 개인의 타고난 재능과 세상에서 만난 경험을 측정하는 검사로, 개인이 자아 발견을 통해 꿈을 찾고 미래를 예측, 설계하여 자아 실현하도록 하는 데 목적이 있다. </p></div><div data-v-66bdb9a2><h2 data-v-66bdb9a2>PUTT2.0 다중재능검사의 특징</h2><p data-v-66bdb9a2> 첫째, 21세기 시대정신–진화론·양자역학·다중적 우주관·게놈 및 커넥톰·역량평가–을 배경으로 한다.<br data-v-66bdb9a2> 둘째, 개인 재능의 생성, 성장, 발현을 주도하는 크고 작은 경험(개인과 세상과의 만남의 결실)을 측정한다.<br data-v-66bdb9a2> 셋째, 개인과 환경과의 복잡한 인과관계를 측정하여 그 성장가능성을 예측한다.<br data-v-66bdb9a2> 넷째, 경험은 세상의 변화에 민감하게 반응하는 지각력, 발달 과업 극복과 세상과의 소통에 필수적인 표상력, 직면하는 다양한 상황에 대처하는 구성력, 자아 실현하고자 노력하는 성취력이 결정하는 것으로, 삶의 과정에서 일어나는 활동들을 측정한다.<br data-v-66bdb9a2> 다섯째, 개인의 내외적 발달과 변화에 최적으로 대처할 수 있는 사람중심의 재능을 측정한다. </p></div>", 3)),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", null, "PUTT2.0 다중재능검사의 구성", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", null, " 본 검사는 2재능계 4재능군 8재능 32척도로 구성되어 있다. 2재능계에는 마음재능계, 정보재능계로 이루어지고 이는 다시 4재능군으로 구분된다. 4재능군은 기호재능군, 형태재능군, 실재재능군, 사물재능군으로, 기호재능군에는 언어재능과 수리재능이, 형태재능군에는시공간재능과 음향재능이, 실재재능군에는 자연재능과 사회재능이, 사물재능군에는 생명체재능과 기계재능 등 총8재능이 속한다. 8재능 각각은 다시 4개의 척도– 지각력·표상력·구성력·성취력–로 구분되고, 모든 문항은 재능별 특수 맥락을 반영하고 있다. ", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              })
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "PUTT2.0 다중재능검사의 발달단계별 구분"),
            _createElementVNode("p", null, [
              _createTextVNode(" 본 검사는 학령기를 4단계–초등학생용·중학생용·고등학생용·대학생용–로 구분, 측정한다."),
              _createElementVNode("br"),
              _createTextVNode(" ‘’PUTT2.0_고등학생용’은 고1 – 고3 학년을 대상으로 하고, 다소 추상적, 맥락적 현상과 사물을 다룬다. 즉, 지식을 기반으로 한 논리적 사고, 다양한 수리적 표상과 해법 활용, 자연 현상 및 물질의 성질, 사회 현상과 그 변화, 관찰 및 분석 기반의 추론과 예측 등의 수준이다. 무엇보다 창출 수준을 포함한다. 이는 총 160 문항으로 구성된다. ")
            ])
          ], -1)),
          _cache[10] || (_cache[10] = _createElementVNode("div", null, [
            _createElementVNode("h2", null, "PUTT2.0 다중재능검사의 결과리포트"),
            _createElementVNode("p", null, " 본 검사 응답 후, 결과리포트_학생용(A4 용지. 4쪽)이 제공되고, 반드시 상담이 병행되어야 한다. ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Product.Testing.Putt.Path}`
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("목록")
              ])),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}
}

})